import CancelIcon from "@mui/icons-material/Cancel";
import {
  Box,
  Chip, FormControl, FormHelperText, MenuItem, Select, Stack
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";

const useStyles = makeStyles((theme) => ({
  rootAppSelect: {
    position: "relative",

    "& .bkg-readonly": {
      position: "absolute",
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 2,
    },
  },
}));

 function AppMultipleSelect({
  label = "",
  value,
  setValue = () => {},
  items = [],
  readOnly = false,
  hasError = false,
  labelError = "",
  callback = () => {},
}) {
  const classes = useStyles();

  /**
   * actions
   */
  const handleItem_change = (e) => {
    setValue(e.target.value);
    callback(e.target.value);
  };
  const handleItem_delete = (id) => {
    setValue(value=> value.filter(value => value !== id))
    callback(id);
  }
  const renderChips = (selected = []) => {
    return items.filter(item => selected.includes(item.id)).map((item, key) => (
        <Chip clickable key={key} label={item.label} deleteIcon={<CancelIcon onMouseDown={(e)=> e.stopPropagation()} />}  onDelete={() =>handleItem_delete(item.id)} />
    ))
  }
  /**
   * renders
   */
  return (
    <Box className={classes.rootAppSelect}>
      <FormControl variant="outlined" size="small" fullWidth>
        <Select
          value={value || []}
          multiple
          onChange={handleItem_change}
          style={{ backgroundColor: "#fff"}}
          renderValue={(selected) => {
            return (
              <Stack direction="row" spacing={0} style={{display: "flex", flexWrap: "wrap"}}>
                {renderChips(selected)}
              </Stack>
            );
          }}
        >
          {items.map((itm, idx) => {
            return (
              <MenuItem key={idx} value={itm.id}>
                {itm.label}
              </MenuItem>
            );
          })}
        </Select>
        {hasError && (
          <FormHelperText style={{ color: "#f44336" }}>
            {labelError}
          </FormHelperText>
        )}
      </FormControl>

      {readOnly && <div className="bkg-readonly" />}
    </Box>
  );
}

export default React.memo(AppMultipleSelect)